import '@babel/polyfill';
import React, {Fragment, Suspense, lazy} from 'react'
import PropTypes from 'prop-types'
import Router from 'next/router';
import Block from '../adapters/helpers/Block';
import contentfulClient from '../adapters/model/ContentfulClient';
import ArticlePageSEO from '../components/SEOschema/ArticlePageSEO'

const Meta = lazy(() => import('../components/Meta/Meta'));
const GTMScriptFunction = lazy(() => import('../components/GTMScriptFunction'));
const Loader = lazy(() => import('../adapters/helpers/Loader'));

class Article extends React.Component {

    componentDidMount() {
        Router.beforePopState(({as}) => {
            location.href = as;
        });
    }

    static async getInitialProps({ asPath }) {
        const client = await contentfulClient.getClient();
        const locales = await client.getLocales();
        const defaultLocale = locales.items.find(locale => locale.default);
        const countryCode = defaultLocale.code.slice(-2);
        const languageCode = defaultLocale.code.substring(0, 2);

        const baseProps = await this.initPage(asPath);
        baseProps.countryCode = countryCode;
        baseProps.languageCode = languageCode;
        return {
            ...baseProps
        }
    }

    static async initPage(slug) {
        let article = undefined;

        // Errors pages doesn't have a page entry in Contentful CMS
        if (slug) {
            const { default: articleDao } = await import('Model/dao/ArticleDao');
            article = await articleDao.getActiveArticleBySlug(slug);
        }
        if(article?.fields?.articleOverview?.fields?.thumbnailImage?.fields){
            article.fields.articleOverview.fields.thumbnailImage.fields.isBannerImage = true
        }
        return {'article' : article};
    }

    constructor(props) {
        super(props);
    }

    /**
     * Rendering of the page. This always render the page using a common layout.
     *
     * Override the render method to do otherwise.
     *
     * @returns {*}
     */
    render() {
        let article = this.getArticle();
        let pagePath = article?.articleOverview?.fields?.slug?.fields?.slug;
        let metaData = this.getMetadata()
        if(metaData){
            metaData.pageType = 'article'
        }
        return (
            <Fragment>
                <Suspense fallback={<Loader />}>
                    <Meta metadata={metaData} pagePath={pagePath} />
                    <ArticlePageSEO metadata={metaData} pagePath={pagePath} article={article} />
                </Suspense>
                <div className="ob-wrapper">
                    <Suspense fallback={<Loader />}>{this.renderBody()}</Suspense>
                </div>
                <Suspense fallback={<Loader />}>
                    <GTMScriptFunction languageCode={this.props.languageCode} countryCode={this.props.countryCode} />
                </Suspense>
            </Fragment>
        )
    }

    getArticle() {
        return this.props?.article?.fields;
    }

    getMetadata() {
        return this.props?.article?.fields?.metadata?.fields;
    }

    /**
     * By default, the page will render the modules of the Product.
     * Can be overridden on the child class to do specific rendering.
     * @returns {*|void}
     */
    renderBody() {
        return new Block(this.props.article).renderChildBlocks({ extraAttributes : {entity: this.getArticle(), breadCrumbData: this.props?.article?.fields.breadCrumb}});
    }
}

Article.propTypes = {
    article: PropTypes.object,
    languageCode: PropTypes.string,
    countryCode: PropTypes.string
}

export default Article
